<template>
  <div
    class="mod-capcha"
    v-bind:class="{'lg': size=== 'large', 'default': size=== 'default', 'sm': size=== 'small'}"
  >
    <a-input
      class="input"
      :max-length="5"
      :size="size"
      v-model="model"
      @change="onInputChange"
      @blur="onBlur"
      :placeholder="placeholder"
    >
      <div class="addons" slot="addonAfter">
        <span class="validate-icon" v-show="validated">
          <l8-icon
            class="l8-icon"
            v-show="!validate"
            type="icon-chahao"
            style="color: #ff0000"
          />
          <l8-icon
            class="l8-icon"
            v-show="validate"
            type="icon-gou1"
            style="color: #4acd0b"
          />
        </span>
        <span class="capcha-btn" @click="refresh">
          <img :src="imgUrl" alt="captcha">
        </span>
      </div>
    </a-input>
  </div>
</template>

<script>
import { fetchImageCaptcha, verifyImageCaptcha } from '@/apis/common'

const tokenKey = 'retail_captcha_token'

export default {
  name: 'l8-imgcaptcha',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: {
      type: String,
      default: 'default'
    },
    placeholder: {
      type: String,
      default: '验证码'
    }
  },
  data () {
    return {
      model: '',
      validate: false,
      imgUrl: '',
      validated: false
    }
  },
  created () {
    this.model = this.value
  },
  mounted () {
    this.fetch()
  },
  methods: {
    async fetch () {
      try {
        const { state, image } = await fetchImageCaptcha()
        this.state = state
        this.imgUrl = image
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    refresh () {
      this.validated = false
      this.validate = false
      this.model = ''
      sessionStorage.removeItem(tokenKey)
      this.fetch()
    },
    async sendCode (value) {
      try {
        const res = await verifyImageCaptcha({
          code: value,
          state: this.state
        })

        sessionStorage.setItem(tokenKey, res)
        this.validate = true
      } catch (e) {
        this.refresh()
        sessionStorage.removeItem(tokenKey)
        this.validate = false
      }

      this.$nextTick(() => {
        this.$emit('change', this.validate ? value : '')
      })
    },
    onInputChange (e) {
      const model = this.model

      if (model.length < 1) {
        this.validate = false
        this.validated = false
        sessionStorage.removeItem(tokenKey)
        this.$emit('change', '')
      } else if (model.length === 5) {
        this.validated = true
        this.sendCode(model)
      } else {
        this.validate = false
        this.validated = true
        sessionStorage.removeItem(tokenKey)
        this.$emit('change', '')
      }
    },
    onBlur () {
      this.$emit('blur', this.model)
    }
  }
}
</script>
